// extracted by mini-css-extract-plugin
module.exports = {"storyblok-page-list":"StoryblokPageList_storyblok-page-list__7_k24","storyblok-page-list__image-container":"StoryblokPageList_storyblok-page-list__image-container__4_CCp"};